import { ApiRes } from "@/api/api-res";

export class UserHistory {
  constructor(public readonly userId: string, public readonly date: Date) {}

  public static fromJson(json: ApiRes.UserHistory): UserHistory {
    return new UserHistory(json.user_id, new Date(json.updated_time_msec));
  }
}
